import { CrudStoreItemPartner360 } from 'legacy/lut/classes/models/partner360/CrudStoreItemPartner360'
import { IWWPartners } from 'legacy/lut/classes/models/partner360/IWWPartners'

import { Logic, Operator } from 'core-components/types'
import { CrudStore } from 'core/types/crudStore'

import { mapToIWWPartners } from '../helpers/mapToIWWPartners'

export const fetchGlobalPartnersEntities = async (
  globalPartnerId: string
): Promise<IWWPartners[]> => {
  const crud = CrudStore.get(
    CrudStoreItemPartner360.JBPPGlobalPartnersEntities,
    'composed-report-fetchGroupPartners'
  )
  crud.setFilter({
    logic: Logic.AND,
    filters: [
      {
        field: 'GroupId',
        operator: Operator.EQUAL,
        value: globalPartnerId,
      },
    ],
  })
  crud.setPaging({ page: 0, pageSize: 5000 })

  const res = await crud.fetch({ force: true })
  return res?.items.map(mapToIWWPartners) || []
}
